import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { get, isObject } from 'lodash';

const baseString = 'vra-gradient';
const Gradient = ({
  className,
  colors,
  displayValues,
  isVisible=true
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    [`${className}`]: !!className
  });

  const gradientBlocks = colors.map((color, index) => {
    const value = get(displayValues, `[${index}]`); // assuming colors array is same length as values...
    const style = {};

    if( isObject(color) ) { // May be a gradient, or may be an RGB mix.
      if(get(color, 'low')) {
        style.background =`linear-gradient(${get(color, 'low')}, ${get(color, 'high')})`;
      } else {
        style.background = `rgb(${color.r}, ${color.g}, ${color.b})`; // Copied from legacy VRA, may not be best solution
      }
    } else {
      style.background = color;
    }

    return (
      <li
        className={`${baseString}__block`}
        key={index}>
        <span className={`${baseString}__color`} style={style} />
        {value && <span className={`${baseString}__value`}>{value}</span>}
      </li>
    );
  });

  return isVisible ? (
    <ul className={classString}>
      {gradientBlocks}
    </ul>
  ) : null;
};
Gradient.propTypes = {
  className: PropTypes.string,
  colors: PropTypes.array.isRequired,
  displayValues: PropTypes.array.isRequired,
  isVisible: PropTypes.bool
};
export default Gradient;
